import { Modal } from 'flowbite-react';
import React, { useState } from 'react';
import { Order, OrderTypeEnum } from '../../Models/Order';
import Loader from '../Common/Loader';

export default function OrderView({
  show,
  setShow,
  // getOrders,
  selectedOrder,
  setSelectedOrder,
}: {
  show: boolean;
  setShow: React.Dispatch<React.SetStateAction<boolean>>;
  // getOrders?: () => Promise<void>;
  selectedOrder: Order | null;
  setSelectedOrder: React.Dispatch<React.SetStateAction<Order | null>>;
}) {
  const [isLoading, setIsLoading] = useState<boolean>(false);

  function onCloseModal() {
    setSelectedOrder(null);
    setShow(false);
  }

  return (
    <>
      <Modal show={show} size='2xl' onClose={onCloseModal} popup>
        <Modal.Header></Modal.Header>
        <Modal.Body>
          <div className='relative'>
            {isLoading && <Loader />}
            <div className='w-full'>
              <div className='w-full'>
                <div className='mx-1 flex items-end justify-center'>
                  <div className='flex flex-1 justify-center'>
                    <h1 className='text-gray-900 font-bold text-4xl'>
                      {selectedOrder?.typeId === OrderTypeEnum.Order
                        ? 'Order'
                        : 'Quote'}{' '}
                      Request
                    </h1>
                  </div>
                </div>
              </div>
              <div>
                <div className='container mx-auto p-2'>
                  <div className='md:flex no-wrap md:-mx-2 '>
                    <div className='w-full'>
                      <div className='bg-white'>
                        <hr className='bg-gray-300 h-[5px]'></hr>
                        <div className='grid grid-cols-[35%_65%] text-md md:text-lg'>
                          <div className='flex'>
                            <div className='font-bold content-center'>
                              Requested by:
                            </div>
                          </div>
                          <div className='w-full'>
                            <span>{selectedOrder?.requestedBy}</span>
                          </div>
                        </div>
                        <div className='grid grid-cols-[35%_65%] text-md md:text-lg'>
                          <div className='flex'>
                            <div className='font-bold content-center'>
                              Requested by:
                            </div>
                          </div>
                          <div className='w-full'>
                            <span>{selectedOrder?.requestedBy}</span>
                          </div>
                        </div>
                        billing information
                        <div className='grid grid-cols-[35%_65%] text-md md:text-lg'>
                          <div className='flex'>
                            <div className='font-bold content-center'>
                              Company Name:
                            </div>
                          </div>
                          <div className='w-full'>
                            <span>{selectedOrder?.companyName}</span>
                          </div>
                        </div>
                        <div className='grid grid-cols-[35%_65%] text-md md:text-lg'>
                          <div className='flex'>
                            <div className='font-bold content-center'>
                              Phone:
                            </div>
                          </div>
                          <div className='w-full'>
                            <span>{selectedOrder?.phone}</span>
                          </div>
                        </div>
                        <div className='grid grid-cols-[35%_65%] text-md md:text-lg'>
                          <div className='flex'>
                            <div className='font-bold content-center'>
                              PO Box:
                            </div>
                          </div>
                          <div className='w-full'>
                            <span>{selectedOrder?.pobox}</span>
                          </div>
                        </div>
                        <div className='grid grid-cols-[35%_65%] text-md md:text-lg'>
                          <div className='flex'>
                            <div className='font-bold content-center'>
                              Email:
                            </div>
                          </div>
                          <div className='w-full'>
                            <span>{selectedOrder?.email}</span>
                          </div>
                        </div>
                        <div className='grid grid-cols-[35%_65%] text-md md:text-lg'>
                          <div className='flex'>
                            <div className='font-bold content-center'>
                              Email invoices to:
                            </div>
                          </div>
                          <div className='w-full'>
                            <span>{selectedOrder?.emailInvoicesTo}</span>
                          </div>
                        </div>
                        delivery information
                        <div className='grid grid-cols-[35%_65%] text-md md:text-lg'>
                          <div className='flex'>
                            <div className='font-bold content-center'>
                              Company or Project Name:
                            </div>
                          </div>
                          <div className='w-full'>
                            <span>{selectedOrder?.projectName}</span>
                          </div>
                        </div>
                        <div className='grid grid-cols-[35%_65%] text-md md:text-lg'>
                          <div className='flex'>
                            <div className='font-bold content-center'>
                              Country:
                            </div>
                          </div>
                          <div className='w-full'>
                            <span>{selectedOrder?.country}</span>
                          </div>
                        </div>
                        <div className='grid grid-cols-[35%_65%] text-md md:text-lg'>
                          <div className='flex'>
                            <div className='font-bold content-center'>
                              Address Line 1:
                            </div>
                          </div>
                          <div className='w-full'>
                            <span>{selectedOrder?.address1}</span>
                          </div>
                        </div>
                        <div className='grid grid-cols-[35%_65%] text-md md:text-lg'>
                          <div className='flex'>
                            <div className='font-bold content-center'>
                              Address Line 2:
                            </div>
                          </div>
                          <div className='w-full'>
                            <span>{selectedOrder?.address2}</span>
                          </div>
                        </div>
                        <div className='grid grid-cols-[35%_65%] text-md md:text-lg'>
                          <div className='flex'>
                            <div className='font-bold content-center'></div>
                          </div>
                          <div className='w-full'>
                            <span>
                              {selectedOrder?.city},{' '}
                              {selectedOrder?.state?.code}{' '}
                              {selectedOrder?.zipCode}
                            </span>
                          </div>
                        </div>
                        <div className='grid grid-cols-[35%_65%] text-md md:text-lg'>
                          <div className='flex'>
                            <div className='font-bold content-center'>
                              Onsite POC:
                            </div>
                          </div>
                          <div className='w-full'>
                            <span>{selectedOrder?.onsitePoc}</span>
                          </div>
                        </div>
                        <div className='grid grid-cols-[35%_65%] text-md md:text-lg'>
                          <div className='flex'>
                            <div className='font-bold content-center'>
                              POC Phone:
                            </div>
                          </div>
                          <div className='w-full'>
                            <span>{selectedOrder?.pocphone}</span>
                          </div>
                        </div>
                        <div className='grid grid-cols-[35%_65%] text-md md:text-lg'>
                          <div className='flex'>
                            <div className='font-bold content-center'>
                              Project Duration:
                            </div>
                          </div>
                          <div className='w-full'>
                            <span>{selectedOrder?.projectDuration}</span>
                          </div>
                        </div>
                        <div className='grid grid-cols-[35%_65%] text-md md:text-lg'>
                          <div className='flex'>
                            <div className='font-bold content-center'>
                              Requested Delivery Date:
                            </div>
                          </div>
                          <div className='w-full'>
                            <span>{selectedOrder?.deliveryDate}</span>
                          </div>
                        </div>
                        <div className='grid grid-cols-[35%_65%] text-md md:text-lg'>
                          <div className='flex'>
                            <div className='font-bold content-center'>
                              Services:
                            </div>
                          </div>
                          <div className='w-full border rounded-md p-1'>
                            {selectedOrder?.orderServices?.map((obj) => (
                              <div key={obj.id}>{obj.option?.name}</div>
                            ))}
                          </div>
                        </div>
                        <div className='grid grid-cols-[35%_65%] text-md md:text-lg'>
                          <div className='flex'>
                            <div className='font-bold content-center'>
                              Products:
                            </div>
                          </div>
                          <div className='w-full border rounded-md p-1'>
                            {selectedOrder?.orderProducts?.map((obj) => (
                              <div key={obj.id}>{obj.option?.name}</div>
                            ))}
                          </div>
                        </div>
                        <div className='grid grid-cols-[35%_65%] text-md md:text-lg'>
                          <div className='flex'>
                            <div className='font-bold content-center'>
                              Equipment:
                            </div>
                          </div>
                          <div className='w-full border rounded-md p-1'>
                            {selectedOrder?.orderEquipments?.map((obj) => (
                              <div key={obj.id}>{obj.option?.name}</div>
                            ))}
                          </div>
                        </div>
                        <div className='grid grid-cols-[35%_65%] text-md md:text-lg'>
                          <div className='flex'>
                            <div className='font-bold content-center'>
                              Schedule:
                            </div>
                          </div>
                          <div className='w-full border rounded-md p-1'>
                            {selectedOrder?.orderSchedules?.map((obj) => (
                              <div key={obj.id}>{obj.option?.name}</div>
                            ))}
                          </div>
                        </div>
                        <div className='grid grid-cols-[35%_65%] text-md md:text-lg'>
                          <div className='flex'>
                            <div className='font-bold content-center'>
                              Notes:
                            </div>
                          </div>
                          <div className='w-full'>
                            <span>{selectedOrder?.notes}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}
